import React, { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getListErrors, ValidateInputs } from "../helper/helper";
import { Loader } from "../components/Loader";
import { LoadingButton } from "../components/LoadingButton";
import API from "../helper/AxiosInterceptor";

const Login = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isTestnet = process.env.REACT_APP_NETWORK_MODE === 'testnet';

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    acceptTermsConditions: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((formData) => ({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    }));
    const updatedInputs = ValidateInputs(name, value, errors);
    setErrors(updatedInputs);
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    }

    if (!formData.acceptTermsConditions) {
      newErrors.acceptTermsConditions = "Please accept terms & conditions";
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validate();
    if (Object.keys(formErrors).length === 0) {
      try {
        setIsLoading(true);
        await API.post(
          `${process.env.REACT_APP_API_URL}/auth/merchant-login`,
          formData
        )
          .then(async (response) => {
            console.log("response.data : ", response?.data);

            if (response?.data.success && response?.data.access_token) {
              localStorage.setItem("token", response.data.access_token);
              toast.success("Login successfully!");
              navigate("/dashboard");
            } else {
              toast.success(response?.data.msg);
              navigate("/verify-otp", { state: { data: { ...formData, ...response.data } } });
            }
          })
          .catch((error) => {
            console.error("error 12", error?.response?.data?.message);
            toast.error(getListErrors(error?.response?.data?.message));
          });
      } catch (error) {
        console.log("catch error", error);
        toast.error(error?.response?.data?.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(formErrors);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <>
      <Header />
      <div className="site-bg">
        <div className="inner-page-warper section-padding">
          <div className="container">
            <div className="form-box">
              <h2>
                {isTestnet ? 'Testnet Login' : 'Welcome Back!'}
              </h2>



              <form onSubmit={handleSubmit}>
                <div className="form-box-inner white-bg">
                  {/* Testnet Credentials Note */}
                  {isTestnet && (
                    <div className="login-info-alert">
                      <div className="d-flex align-items-center">
                        <i className="ti ti-info-circle mr-2" style={{ fontSize: '20px', color: '#e9c02f', marginRight: '10px' }} />
                        <p>
                          Use your exact same <strong>PayCoinz credentials</strong> to log in. This is a secure sandbox for testing.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Mainnet Create Account Note */}
                  {!isTestnet && (
                    <div className="login-info-alert">
                      <div className="d-flex align-items-center">
                        <i className="ti ti-info-circle mr-2" style={{ fontSize: '20px', color: '#e9c02f', marginRight: '10px' }} />
                        <p>
                          To create an account, <Link to="/inquire-now" style={{ color: "var(--yellow)", fontWeight: "600", textDecoration: "underline" }}>click here</Link> and submit the form. You will receive your login credentials within two days.
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="form-group">
                    <label>Email</label>
                    <div className="form-group-inner">
                      <div className="fild-icon">
                        <i className="ti ti-mail" />
                      </div>
                      <input
                        type="text"
                        placeholder="Enter Email"
                        name="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <span className="error">{errors.email}</span>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <div className="form-group-inner password-fild-box">
                      <div className="fild-icon">
                        <i className="ti ti-lock" />
                      </div>
                      <input
                        type={passwordVisible ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter Password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      {errors.password && (
                        <span className="error">{errors.password}</span>
                      )}
                      <div
                        className="eye-view-btn"
                        onClick={togglePasswordVisibility}
                      >
                        <i
                          className={`ti ${passwordVisible ? "ti-eye-off" : "ti-eye"
                            }`}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="terms-conditions-box">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="acceptTermsConditions"
                        checked={formData.acceptTermsConditions}
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        Accept{" "}
                        <Link
                          to="/terms-conditions"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms &amp; Conditions
                        </Link>
                      </label>
                    </div>
                    {errors.acceptTermsConditions && (
                      <span className="error">
                        {errors.acceptTermsConditions}
                      </span>
                    )}
                  </div>
                  <div className="form-submit-btn">
                    <LoadingButton
                      type="submit"
                      isLoading={isLoading}
                      className="btn"
                    >
                      Log In
                    </LoadingButton>
                  </div>
                  <div className="forgot-btn">
                    <Link to="/forget-password">Forgot Password</Link>
                  </div>


                </div>
              </form>
              <div className="form-shape-box1">
                <img src="images/shape1.png" alt="shape" />
              </div>
              <div className="form-shape-box2">
                <img src="images/shape2.png" alt="shape" />
              </div>
              <div className="form-shape-box3">
                <img src="images/shape3.png" alt="shape" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Show footer only on mainnet */}
      {!isTestnet && <Footer />}
    </>
  );
};

export default Login;
